const imagesBaseURL =
  "https://res.cloudinary.com/big-oven-tees-inc/image/upload/v1609952813/Shirtly/Shirtly_Products_Mock";
const baseURL = "https://bot2-app.herokuapp.com";
// const baseURL = "https://656b-2607-fea8-b5f-25d0-d999-82a7-e005-f9b0.ngrok-free.app";

const requests = {
  bulkStripeCharge: "/bulkStripeCharge",
  allSyncedProducts: "/allSyncedProducts",
  deleteUnSyncedOrders: "/deleteUnSyncedOrders",
  automationToggle: "/automationToggle",
  submitOrderToAU: "/submitOrderToAU",
  editSKUInformation: "/EditSKUInformation",
  packingUpdate: "/PackingUpdate",
  getInventory: "/GetInventoryDto",
  getShipstationCarriers: "/getShipstationCarriers",
  getShipstationRates: "/getShipstationRates",
  getTags: "/GetTags",
  getColors: "/GetColorGroups",
  // getProducts: '/GetProductsFiltered',
  getAllProducts: "/GetAllProducts",
  getProduct: "/GetOneProduct",
  getStores: "/GetStoreInfo",
  getOrders: "/GetOrders",
  createOrder: "/CreateOrder ",
  getOrderDetail: "/GetOrderDetails?orderId=",
  submitOrderToEU: "/submitOrderToEU",
  getCountries: "/GetCountry",
  machineOrderDetails: "/MachineOrderDetails",
  deleteOrder: "/DeleteOrder",
  addlineItem: "/LineItem ",
  editOrderCustomerInformation: "/EditOrderCustomerInformation",
  updateSavedOrderData: "/UpdateSavedOrderData",
  updateStatus: "/UpdateStatus",
  saveOrderData: "/SaveOrderData",
  removeLineItem: "/RemoveLineItem ",
  getFulfillmentCost: "/GetFulfillmentCost",
  getDesigns: "/GetDesigns",
  clearArtWork: "/ClearArtWork",
  submitOrderToCanada: "/submitOrderToCanada",
  submitOrderToUSA: "/submitOrderToUSA",
  stripeCharge: "/stripeCharge",
  getShopifyOrders: "/getShopifyOrders",
  getShopifyOrder: "/getShopifyOrder",
  getShopifyProducts: "/getShopifyProducts",
  getWooProducts: "/getWooProducts",
  getEtsyOrders: "/getEtsyOrders",
  getAllCards: "/getAllCards",
  login: "/Login",
  signUp: "/SignUp",
  userData: "/UserData",
  updateUserInfo: "/updateUserInfo",
  notifyNewUser: "/NotifyNewUser",
  etsyLoginUrl: "/etsyLoginUrl",
  getFinalEtsyCred: "getFinalEtsyCred",
  removeStore: "/RemoveStore",
  getOrderById: "/getOrderById",
  removeCard: "/removeCard",
  deactivateUser: "/deactivateUser",
  updatePassword: "/updatePassword",
  updateCost: "/UpdateCost",
  generateMocks: "/GenerateMocks",
  getSyncedProducts: "/getSyncedProducts",
  removeSyncedProducts: "/removeSyncedProducts",
  getPreDesigns: "/GetPreDesigns",
  GetPhraseDesigns: "/GetPhraseDesigns",
  allSubmittedOrders: "/AllSubmittedOrders",
  searchAllSubmittedOrders: "/SearchAllSubmittedOrders",
  updateChargeInformation: "/UpdateChargeInformation",
  orderSubmitNotification: "/OrderSubmitNotification",
  marketPlaceOrderDetails: "/MarketPlaceOrderDetails",
  getAllSubmittedUsers: "/GetAllSubmittedUsers",
  getSearchedSubmittedUsers: "/GetSearchedSubmittedUsers",
  updateUserStatus: "/UpdateUserStatus",
  userSubmittedOrder: "/UserSubmittedOrder",
  filterAllSubmittedOrders: "/FilterAllSubmittedOrders",
  cancelOrderFromMachine: "/CancelOrderFromMachine",
  calaculateTax: "/CalaculateTax",
  chargeInformation: "/ChargeInformation",
  editProduct: "/EditProductInformation",
  editSizeInformation: "/EditSizeInformation",
  saveArtFiles: "/SaveArtFiles",
  downloadArtFile: "/DownloadArtFile",
  editColorsInformation: "/EditColorsInformation",
  editDesignerSettings: "/EditDesignerSettings",
  editPrintProvidersInformation: "/EditPrintProvidersInformation",
  deleteProduct: "/DeleteProduct",
  paypalCharge: "/paypalCharge",
  getPaypalTransactionId: "/getTransactionId",
  getAllDTGPlus: "/GetAllDTGPlus",
  editDTGPlusInformation: "/EditDTGPlusInformation",
  updateDTGPlusInfo: "/UpdateDTGPlusInfo",
  deleteDTGPlusInfo: "/DeleteDTGPlusInfo",
  orderShippedNotification: "/OrderShippedNotification",
  getTrackingCANumber: "/getTrackingCANumber",
  getTrackingUSNumber: "/getTrackingUSNumber",
  generateArtboard: "/generateArtboard",
  editArtworkSettings: "/EditArtworkSettings",
  dateFilterAllSubmittedOrders: "/DateFilterAllSubmittedOrders",
  declineBotUser: "/declineBotUser",
  approveBotUser: "/approveBotUser",
  getAllGroups: "/GetAllGroups",
  createGroup: "/CreateGroup",
  getThisGroupData: "/GetThisGroupData",
  updateGroup: "/UpdateGroup",
  updateGroupProducts: "/UpdateGroupProducts",
  syncGroupProducts: "/SyncGroupProducts",
  updatePickUp: "/UpdatePickUp",
  updateLabelPrint: "/UpdateLabelPrint",
  updatePaymentSkip: "/UpdatePaymentSkip",
  allOrderReport: "/AllOrderReport",
  editProductAdditionalImages: "/EditProductAdditionalImages",
  clearAdditionalImages: "/ClearAdditionalImages",
  forgotPassword: "/ForgotPassword",
  technoInventoryCA: "/technoInventoryCA",
  technoInventoryUSA: "/technoInventoryUSA",
  ssactivewearUSproducts: "/ssactivewearUSproducts",
  ssactivewearCAproducts: "ssactivewearCAproducts",
  alphaInventoryCA: "/alphaInventoryCA",
  alphaInventoryUS: "/alphaInventoryUS",
  getSLAData: "/getSLAData",
  allUserOrderReport: "/AllUserOrderReport",
  technoInventoryCApaymentProfile: "/technoInventoryCApaymentProfile",
  technoInventoryUSApaymentProfile: "/technoInventoryUSApaymentProfile",
  technoInventoryCASubmitOrder: "/technoInventoryCASubmitOrder",
  technoInventoryUSASubmitOrder: "/technoInventoryUSASubmitOrder",
  saveSSActiveWearCAStockOrderData: "/SaveSSActiveWearCAStockOrderData",
  saveSSActiveWearUSAStockOrderData: "/SaveSSActiveWearUSAStockOrderData",
  getStockSubmittedOrders: "/getStockSubmittedOrders",
  syncProductsFromShirtly: "/syncProductsFromShirtly",
  saveProductsInBot: "/saveProductsInBot",
  linxOrderPrintifyDataUS: "/linxOrderPrintifyDataUS",
  linxOrderPrintifyEventDataUS: "/linxOrderPrintifyEventDataUS",
  linxOrderPrintifyDataCA: "/linxOrderPrintifyDataCA",
  linxOrderPrintifyEventDataCA: "/linxOrderPrintifyEventDataCA",
  linxStockProdDataUS: "/linxStockProdDataUS",
  linxStockProdDataCA: "/linxStockProdDataCA",
  DuplicateOrder: "/DuplicateOrder",
  getAllSubmittedUsersCSV: "/GetAllSubmittedUsersCSV",
  uploadArtToCloudinary: "/uploadArtToCloudinary",
  editAdditionalTechniquesArtSettings: "/EditAdditionalTechniquesArtSettings",
  editPrintAreas: "/EditPrintAreas",
  allSubmittedOrdersForProduct: "AllSubmittedOrdersForProduct",
  checkAppVersion: "/CheckAppVersion",
  orderDurasoftNotification: "/OrderDurasoftNotification",
  OrderTuffPrintTransferNotification: "/OrderTuffPrintTransferNotification",
  orderAOPNotification: "/OrderAOPNotification",
  getPlusArtFiles: "/getPlusArtFiles",
  wooAuth: "/wooAuth",
  wooAllOrders: "/wooAllOrders",
  syncProduct: "/syncProduct",
  syncedProducts: "/syncedProducts",
  getShopifyCountProducts: "/getShopifyCountProducts",
  syncedProductsCount: "/syncedProductsCount",
  getShopifyMoreProducts: "/getShopifyMoreProducts",
  getWooMoreProducts: "/getWooMoreProducts",
  syncedProduct: "/syncedProduct",
  updateSyncedProduct: "/updateSyncedProduct",
  getThisProduct: "/getThisProduct",
  closeShopifyOrder: "/closeShopifyOrder",
  getShopifyOrdersCount: "/getShopifyOrdersCount",
  getShopifyMoreOrders: "/getShopifyMoreOrders",
  wooMoreOrders: "/wooMoreOrders",
  pdf2json: "/pdf2json",
  staplesProgramPdf2json: "/staplesProgramPdf2json",
  iPromoteuPdf2json: "/iPromoteuPdf2json",
  updateStaplesOrder: "/updateStaplesOrder",
  updateStaplesProgramOrder: "/updateStaplesProgramOrder",
  allStaplesOrders: "/allStaplesOrders",
  allStaplesProgramOrders: "/allStaplesProgramOrders",
  allIPromoteuOrders: "/allIPromoteuOrders",
  getStaplesOrder: "/getStaplesOrder",
  getStaplesProgramOrder: "/getStaplesProgramOrder",
  getIPromoteuOrder: "/getIPromoteuOrder",
  updateRecievedQty: "/updateRecievedQty",
  saveAllCosts: "/SaveAllCosts",
  saveCard: "/saveCard",
  getStaplesDesigns: "/GetStaplesDesigns",
  clearStaplesArtwork: "/ClearStaplesArtwork",
  searchDesigns: "/SearchDesigns",
  searchBOTDesigns: "/SearchBOTDesigns",
  allWebPages: "/AllWebPages",
  webPage: "/WebPage",
  addDashboardSection: "/AddDashboardSection",
  updateDashboardSection: "/UpdateDashboardSection",
  deleteDashboardSection: "/DeleteDashboardSection",
  orbitkitOrders: "/Orbitkit/Orders",
  orbitkitOrderEvents: "/Orbitkit/OrderEvents",
  declineOrbitkitOrder: "/OrbitKit/UpdateOrder",
  saveVendorReferenceData: "/saveVendorReferenceData",

  proformaOrders: "/Proforma/Orders",
  proformaOrderEvents: "/Proforma/OrderEvents",
  declinePerformaOrder: "/Proforma/UpdateOrder",
  proformaArtFiles: "/Proforma/Artfiles",

  cottonCandyOrders: "/Cottoncandy/Orders",
  cottonCandyOrderEvents: "/Cottoncandy/OrderEvents",
  declineCottonCandyOrder: "/Cottoncandy/UpdateOrder",

  fastPlatformOrders: "/Fastplatform/Orders",
  updateFastplatformOrderStatus: "/Fastplatform/UpdateOrder",

  smartPinkSinkOrders: "/Smartprintsink/Orders",
  smartPrintsInkOrderEvents: "/Smartprintsink/OrderEvents",
  declineSmartPrintsInkOrder: "/Smartprintsink/UpdateOrder",

  wamiSwagOrders: "/Wamiswag/Orders",
  wamiswagOrderEvents: "/Wamiswag/OrderEvents",
  declineWamiswagOrder: "/Wamiswag/UpdateOrder",

  briklOrders: "/Brikl/Orders",
  briklOrderEvents: "/Brikl/OrderEvents",
  briklOrderUpdateOrder: "/Brikl/UpdateOrder",

  imsRetailOrders: "/Imsretail/Orders",
  imsRetailOrder: "/Imsretail/Order",
  imsRetailOrderEvents: "/Imsretail/OrderEvents",
  imsRetailOrderUpdateOrder: "/Imsretail/UpdateOrder",
  imsRetailLogos: "/Imsretail/Logos",
  imsRetailSendMultipleOrderTracking: "/Imsretail/SendMultipleOrderTracking",

  americanDiversityOrders: "/Americanmin/Orders",
  americanDiversityOrderEvents: "/Americanmin/OrderEvents",
  americanDiversityArtFiles: "/Americanmin/Artfiles",

  imsRetailShippingPrice: "/IMSRetail/ShippingPrice?orderNumber=",
  imsSendTrackingSheet: "/IMSRetail/SendTrackingSheet",
  addNotes: "/IMSRetail/AddNotes",

  americanBusinessOrders: "/Americanbus/Orders",
  americanBusinessOrderEvents: "/Americanbus/OrderEvents",
  americanBusinessArtFiles: "/Americanbus/Artfiles",

  blinkSwagOrders: "/Blinkswag/Orders",
  blinkSwagOrderEvents: "/Blinkswag/OrderEvents",
  declineBlinkSwagOrder: "/Blinkswag/UpdateOrder",

  updateScreenPrintingInfo: "/UpdateScreenPrintingInfo",
  getAllScreenPrinting: "/GetAllScreenPrinting",
  deleteScreenPrintingInfo: "/DeleteScreenPrintingInfo",

  deleteBulkOrders: "/deleteBulkOrders",
  setPrintProvider: "/setPrintProvider",
  sendEmail: "/sendEmail",
  getZazzlePriceList: "/getZazzlePriceList",
};

export { baseURL, requests, imagesBaseURL };
